import type { TechnicalDataScenario } from "features/technical-data/scenario/model/types";

import {
  createDefaultScenarioDefinition,
  findReactiveParameter,
  findTryFile,
  type ScenarioDefinitionFormState,
} from "../model/transientScenario";

export const mapTrScenarioToFormState = (scenario: TechnicalDataScenario): ScenarioDefinitionFormState => ({
  ...createDefaultScenarioDefinition(scenario.id, scenario.name),
  dayNightFlushing: scenario.dayNightFlushing,
  detailed_simulation_needed: scenario.detailedSimulationNeeded,
  measured_weather_data: scenario.measuredWeatherData,
  reactive_parameter: findReactiveParameter(scenario.reactiveParameter) ?? "load",
  requiredTMax: scenario.requiredTMax,
  requiredTMin: scenario.requiredTMin,
  t_supply_dynamic: scenario.tSupplyDynamic,
  try_file: findTryFile(scenario.tryFile) ?? "TRY2015_Jahr",
  weather_data_year: scenario.weatherDataYear,
});
